import { render, staticRenderFns } from "./FeeBudgetEdit.vue?vue&type=template&id=51f032cb"
import script from "./FeeBudgetEdit.vue?vue&type=script&lang=js"
export * from "./FeeBudgetEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports